import ModuleCard from './ModuleCard.vue';

export default ModuleCard;



// WEBPACK FOOTER //
// ./src/components/parts/modules/card/index.ts